/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-12-14                                                        *
 ******************************************************************************/

import { createRouter, createWebHashHistory } from 'vue-router';


import Yega1UserProfileForm from '../../components/yega/yega1/yega1-user-profile-form.vue';
import ProductSelection from '../../components/dynabook_shared/product-selection.vue';
import Navigation from "./views/navigation.vue";
import ConfigureBto from "../../components/dynabook_shared/configure-bto.vue";
import QuoteSummary from "../../components/dynabook_shared/quote-summary.vue";
import ReconfigureBto from "../../components/dynabook_shared/reconfigure-bto.vue";
import ConfigureAccessories from "../../components/dynabook_shared/configure-accessories.vue";
import PartSearch from "../../components/dynabook_shared/part-search.vue";
import ProductCategorySelection from "@/components/dynabook_shared/product-category-selection.vue";
import QuoteRequestInfo from "@/components/dynabook_shared/quote-request-info.vue";

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/profile',
            components:{navigation:Navigation,main:Yega1UserProfileForm},
            name: 'user_profile_path'
        },
        { path: '/select-product-category/:parent_category_id?',
            components:{
                navigation:Navigation,
                main:ProductCategorySelection
            },
            props:{
                main: {
                    isPublic: true
                }
            },
            name: 'product_category_selection_path'
        },
        // {
        //     path: '/home',
        //     components:{navigation:Navigation,main:ProductSelection},
        //     props:{
        //         main: {
        //             useCurrentUser: true
        //         }
        //     },
        //     name: 'product_selection_path'
        // },
        {
            path: '/configure-bto/:template_id',
            components:{navigation:Navigation,main:ConfigureBto},
            props:{
                main: {
                    dialogAttributesList: [{key: 'product-class', label: 'Product Class'}],
                    dialogPricesList:[{key:'esup',label:'MSRP'}],
                    summaryPriceName:'esup',
                    isPublic: true
                }
            },
            name: 'configure_bto_path'
        },
        { path: '/reconfigure-bto/:quote_version_id/:quote_part_id/:quote_product_id',
            components:{
                navigation:Navigation,
                main:ReconfigureBto
            },
            props:{
                main: {
                    dialogAttributesList: [{key: 'product-class', label: 'Product Class'}],
                    dialogPricesList:[{key:'esup',label:'MSRP'}],
                    summaryPriceName:'esup',
                    isPublic: true
                }
            },
            name: 'reconfigure_bto_path'
        },
        { path: '/configure-accessories/:template_id',
            components:{
                navigation:Navigation,
                main:ConfigureAccessories
            },
            props:{
                main: {
                    dialogPricesList:[{key:'esup',label:'MSRP'}],
                    summaryPriceName:'esup',
                    isPublic: true
                }
            },
            name: 'configure_accessories_path'
        },
        {
            path: '/quote',
            components:{navigation:Navigation,main:QuoteSummary},
            props:{
                main: {
                    hasYourPrice: true
                }
            },
            name: 'quote_path'
        },
        {
            path: '/quote-request',
            components:{navigation:Navigation,main:QuoteRequestInfo},
            props:{
                main: {
                }
            },
            name: 'quote_request_path'
        },
        {
            path: '/part-search',
            components:{ navigation:Navigation, main:PartSearch },
            props:{
                main: {
                    searchMacroName:'dynabook_standard_part_number_search',
                    partNumberAttributeName:'standard_quote_lookedup_part_number',
                    productDescriptionAttributeName:'standard_quote_product_description',
                    isPublic: true
                }
            },
            name: 'part_search_path'
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: { name:'product_category_selection_path'}
        }
    ]
});

export default router;
